<!--
~ Copyright (c) RECREWT GmbH 2022.
-->

<div
  [style.backgroundColor]="config?.backgroundColor"
  [style.color]="config?.color"
  class="tag width-wrap-content"
  fxLayoutAlign="center center"
  >
  <span
    #tooltip="matTooltip"
    [matTooltipDisabled]="!config?.desc"
    [matTooltip]="config?.desc ?? '' | translate"
    class="mat-caption no-pad"
    matTooltipClass="tooltip"
    matTooltipPosition="above"
    matTooltipShowDelay="500"
    >
    {{ config?.text ?? '' | translate: { arg: config?.arg } }}
  </span>
  @if (config?.icon) {
    <mat-icon [style.color]="config?.color" class="icon">{{
      config?.icon
    }}</mat-icon>
  }
</div>
